var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"center mb-2"},[_c('button',{on:{"click":_vm.goToHome}},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-mibodega-white.png"),"alt":"logo","height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"center text"},[_vm._v("Mi bodega, tu bodega.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ffe485","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pago/app-header.vue
// module id = 403
// module chunks = 1 2 3 4